import { render } from "./MailMagazineForm.vue?vue&type=template&id=a0f21532&scoped=true&ts=true"
import script from "./MailMagazineForm.vue?vue&type=script&lang=ts"
export * from "./MailMagazineForm.vue?vue&type=script&lang=ts"

import "./MailMagazineForm.vue?vue&type=style&index=0&id=a0f21532&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0f21532"]])

export default __exports__